import { useTranslation } from "react-i18next";
import { Outlet } from "react-router";

import { Page } from "@/components/page";
import { SectionLayout } from "@/components/section-layout";
import { useMe } from "@/lib/api";
import { visibleSettingsGroups } from "@/lib/navigation";

/**
 * The Settings area, a layout route under `/settings`: its own navigation
 * with the section that is open (Account, About, for admins the activity
 * log, and for developers Bekijken als, hidden while they view the dashboard
 * as someone; the dashboard's accounts and the connector's teams have their
 * own page in the sidebar, Mensen en teams). `SectionLayout` puts the
 * navigation in a column beside the section when the area is wide enough,
 * and in a row of tabs above it otherwise, so the section's tables keep their
 * width.
 */
export function SettingsLayout() {
  const { data: me } = useMe();
  // Re-renders the Settings navigation on a language switch: its labels are read at render.
  const { t } = useTranslation();
  const groups = visibleSettingsGroups(me?.role, Boolean(me?.view_as));

  return (
    <Page title={t("nav.settings")}>
      <SectionLayout label={t("nav.settings")} groups={groups}>
        <Outlet />
      </SectionLayout>
    </Page>
  );
}
